import React, { useContext, useEffect, useState } from 'react'

//imagenes
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import tarjetasIcon from "../../assets/img/tarjetas.svg";
import { useParams, useNavigate } from 'react-router-dom';
import ConexContext from '../../context/ConexContext';
import { formatFecha } from '../JS/formato';
import ModalGenericoUsuario from "../modales/ModalGenericoUsuario";

const PerfilTarjeta = () => {
	const { peticion, tipo_usuario, id_usuario } = useContext(ConexContext);
	const { tarjeta } = useParams();
	const navigate = useNavigate();

	const [datosTarjCopy, setDatosTarjCopy] = useState(null); //datos tarjeta copia
	const [datosTarj, setDatosTarj] = useState(null); //datos tarjeta
	const [mensaje, setMensaje] = useState(null); //mensaje de error
	const [datosDepartamentos, setDatosDepartamentos] = useState([]) //select departamentos
	const [modalModificar, setmodalModificar] = useState(false); //modal modificar tarjeta

	/**
	 * Carga los datos de la tarjeta y los departamentos
	 */
	useEffect(() => {
		const datos_tarjetas = async () => {
			setMensaje(null);
			if (!datosTarj) {
				let res = await peticion(`/datos_tarjeta?tarjeta=${tarjeta}`, { method: 'GET' });
				if (res?.estado ?? true) return setMensaje('Se ha producido un error');
				if (res?.res ?? false) {
					setDatosTarj(res["res"]);
					setDatosTarjCopy(res["res"]);
				} else {
					setMensaje(res?.mensaje ?? 'Error al cargar los datos de la tarjeta');
				}
			}
		} 

		if (tarjeta && ((tipo_usuario === '5' || tipo_usuario === '2' || tipo_usuario === '3' || tipo_usuario === '0')))
			datos_tarjetas();
		else //si no, muestra mensaje de error
			setMensaje('No tienes permisos para ver este usuario');
	}, [tarjeta, tipo_usuario, id_usuario, peticion, datosDepartamentos, datosTarj]);

	/**
	 * Obtiene los datos de las entidades, empresas y departamentos para los selects
	 */
	useEffect(() => {
		const datos_dptos = async () => {
			peticion(`/distinc_select`, {
				method: "POST",
				json: {
					"campos": ["cod_ent", "cod_emp", "cod_dpto", "nombre_dpto"],
					"tabla": "i6departamento"
				},
			})
			.then(res => {
				if (res?.estado ?? true) return setMensaje("Se ha producido un error");
				if (res?.res ?? false) setDatosDepartamentos(res["res"]["res"]);
			})
			.catch(error => {
				setMensaje("Se ha producido un error");
			});
		};
		datos_dptos();
	}, [peticion]);

	/**
	 * Obtiene las diferencias entre dos objetos
	 * @param {Object} obj1 
	 * @param {Object} obj2 
	 * @returns diferencias
	 */
	const getDiferentes = (obj1, obj2) => {
		const diferentes = {};
		for (const key in obj2) {
			if (obj1[key] !== obj2[key]) {
				diferentes[key] = obj2[key];
			}
		}
		return diferentes;
	};

	/**
	 * Modifica los datos de la tarjeta
	 */
	const modTarj = async () => {
		let diferencias = getDiferentes(datosTarjCopy, datosTarj);
		if (Object.keys(diferencias).length === 0) return
		// Añadir campo entidad
		diferencias["tarjeta"]=tarjeta
		const res = await peticion(`/guardar_datos_tarjeta`, {
			method: 'POST', json: diferencias
		});
		if (res?.estado ?? true) return setMensaje('Se ha producido un error'); //error
		if (res?.mensaje !== 'OK' ?? false) return setMensaje(res?.mensaje ?? 'Error al cambiar la tarjeta '+datosTarj?.pan_mask+''); //errores
		setDatosTarjCopy({ ...datosTarj });
		return 0;
	}

	/**
	 * Genera las opciones del select de departamentos de forma recursiva, anidando los hijos
	 * @param {Object} departamentos 
	 * @param {Number} nivel 
	 * @returns 
	 */
	const generarOpcionesSelect = (departamentos, nivel = 0) => {
		const tab = String.fromCharCode(0x2003).repeat(nivel); //añade tabulaciones según el nivel
		return departamentos.map(departamento => {
			if(departamento.cod_ent !== datosTarj.cod_ent || departamento.cod_emp !== datosTarj.cod_emp) return null;
			return (
				<React.Fragment key={departamento.cod_dpto + departamento.cod_ent + departamento.cod_emp}>
					<option value={departamento.cod_dpto}>
						{tab}{`${departamento.nombre_dpto} `}({`${departamento.cod_dpto}`})
					</option>
					{departamento.hijos && departamento.hijos.length > 0 &&
						generarOpcionesSelect(departamento.hijos, nivel + 1)}
				</React.Fragment>
			);
		});
	}

	return (
		<>
			<div className="col-xs-12 tabla" id='user-mng' >
			<div
				className="breadcrumbs">
					<span 
					onClick={() => {
						navigate("/administracion/tarjetas");
					}}>Tarjetas</span>
					/ {datosTarj?.pan_mask.toString()}
				</div>
				<div className='section-header'>
					<div className='img-container'>
						<img src={tarjetasIcon} alt=''></img>
					</div>
					<div>
						<h2>Tarjeta</h2>
						<h3>
							{/* <strong>Listado</strong> /  */}
							{datosTarj?.pan_mask ?? ''}
						</h3>
					</div>
				</div>
				<main>
					{!datosTarj && !mensaje ? //si no hay datos ni mensaje, está cargando
						<h1 className="cargando">Cargando...</h1>
						: mensaje ? //si hay mensaje, muestra el mensaje (error)
							<h1 className="cargando">{mensaje}</h1>
							: //si hay datos, muestra los datos
							<>
								<form>
									<div className='form-item'>
										<label>Número de tarjeta</label>
										<input
											type='text'
											placeholder='Número de tarjeta'
											value={datosTarj?.pan_mask ?? ''}
											disabled={true}
											className={"disabled"}
											maxLength={50}
											onChange={(e) => setDatosTarj({ ...datosTarj, pan_mask: e.target.value })}
										/>
									</div>
									<div className='form-item'>
										<label>Entidad</label>
										<input
											type='text'
											placeholder='Código de entidad'
											value={`${datosTarj?.nombre_ent ?? ''} (${datosTarj?.cod_ent ?? ''})`}
											disabled={true}
											className={"disabled"}
											maxLength={4}
											onChange={(e) => setDatosTarj({ ...datosTarj, cod_ent: e.target.value })}
										/>
									</div>
									<div className='form-item'>
										<label>Código de empresa</label>
										<input
											type='text'
											placeholder='Código de empresa'
											value={`${datosTarj?.nombre_emp ?? ''} (${datosTarj?.cod_emp ?? ''})`}
											disabled={true}
											className={"disabled"}
											maxLength={10}
											onChange={(e) => setDatosTarj({ ...datosTarj, cod_emp: e.target.value })}
										/>
									</div>
									<div className="form-item">
										<label>Código de departamento</label>
										<select
											type="text"
											placeholder="Código de departamento"
											value={datosTarj?.cod_dpto ?? ""}
											disabled={tipo_usuario === "1" ? true : false}
											className={""}
											maxLength={12}
											onChange={(e) =>
												setDatosTarj({ ...datosTarj, cod_dpto: e.target.value })
											}
										>
										<option value="">Selecciona un departamento</option>
										{datosDepartamentos &&
											generarOpcionesSelect(datosDepartamentos)
										}
										</select>
									</div>
									<div className='form-item'>
										<label>Nombre del titular</label>
										<input
											type='text'
											placeholder='Nº identificación de tarjeta'
											value={datosTarj?.nombre_usuario ?? 'Sin nombre de titular'}
											disabled={true}
											className={"disabled"}
											maxLength={10}
											onChange={(e) => setDatosTarj({ ...datosTarj, nombre_usuario: e.target.value })}
										/>
									</div>
									<div className='form-item'>
										<label>NIF del titular</label>
										<input
											type='text'
											placeholder='Nº identificación de tarjeta'
											value={datosTarj?.nif_tarjeta ?? ''}
											disabled={true}
											className={"disabled"}
											maxLength={10}
											onChange={(e) => setDatosTarj({ ...datosTarj, nif_tarjeta: e.target.value })}
										/>
									</div>
									<div className='form-item'>
										<label>Fecha de alta</label>
										<input
											type='text'
											placeholder='Fecha de alta'
											value={formatFecha(datosTarj.fecha_alta.toString(), "ISO8601", "esp") ??  'No hay fecha de alta'}
											disabled={true}
											className={"disabled"}
											onChange={(e) => setDatosTarj({ ...datosTarj, fecha_alta: e.target.value })}
										/>
									</div>
									<div className='form-item'>
										<label>Tarjeta padre</label>
										<input
											type='text'
											placeholder='Tarjeta padre'
											value={datosTarj.tarj_padre ??  'No hay tarjeta padre'}
											disabled={true}
											className={"disabled"}
											maxLength={50}
											onChange={(e) => setDatosTarj({ ...datosTarj, tarj_padre: e.target.value })}
										/>
									</div>
								</form>
								<div className='button-container'>
									<button className={(datosTarjCopy && datosTarj && (Object.keys(getDiferentes(datosTarjCopy, datosTarj)).length === 0))?('cta desactiva'):('cta')} onClick={() => setmodalModificar(true)}>Guardar</button>
								</div>
							</>
					}
				</main>
				<ModalGenericoUsuario
					texto1={"¿Quiere modificar esta tarjeta?"}
					texto2={"Tarjeta modificada correctamente"}
					texto3={"Modificar tarjeta"}
					texto4={mensaje}
					setMensaje={setMensaje}
					navegar={() => navigate("/tarjeta/" + datosTarj.pan)}
					navegarError={() => navigate("/tarjeta/" + datosTarj.pan)}
					show={modalModificar}
					onHide={() => setmodalModificar(false)}
					func={modTarj}
				/>
			</div>
		</>
	)
}

export default PerfilTarjeta